import { imageInfo } from '@src/api/apiCloud'
import { CONCURRENCY_LIMIT } from '@src/constant'
import { imagesFromZip } from '@src/helpers/imagesFromZip'
import { MainPageStoreContext } from '@src/pages/MainPageStore'
import { useAnalyze } from '@src/pages/hooks/useAnalyze'
import { useContext } from 'react'

export const useMainPageLogic = () => {
    const store = useContext(MainPageStoreContext)
    const { worker } = useAnalyze()

    const handleFiles = async (files: File[]) => {
        let allFiles = [...files]

        for (const file of files) {
            if (!file.name.endsWith('.zip')) {
                continue
            }
            store.setUnzipStatus(true)
            const zipImages = await imagesFromZip(file)
            allFiles = allFiles.filter(f => f !== file).concat(zipImages)
            store.setUnzipStatus(false)
        }

        store.addTotalFiles(allFiles)
        store.addFilesToRequest(store.totalFiles)

        const workers: Promise<void>[] = []
        for (let i = 0; i < CONCURRENCY_LIMIT; i++) {
            workers.push(worker())
        }

        await Promise.all(workers)
    }

    const handleFilesByLink = async (link: string) => {
        const { data } = await imageInfo(link)

        const files = data._embedded.items.filter(item => item.type === 'file')

        store.addTotalFilesByLink(files)
        store.addFilesToRequest(store.totalFiles)

        const workers: Promise<void>[] = []
        for (let i = 0; i < CONCURRENCY_LIMIT; i++) {
            workers.push(worker())
        }

        await Promise.all(workers)
    }

    return { store, handleFiles, handleFilesByLink }
}
